export default __webpack_public_path__ + "static/media/01__o_2.4ad2b924.jpg";